import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { FeeConfig, FeeConfig$reflection } from "../../GlobalTypes.js";
import { record_type, lambda_type, unit_type, bool_type, int32_type, option_type, class_type, string_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { compare as compare_1, toString, equals as equals_2, op_Division, op_Addition, op_Multiply, fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { singleton as singleton_1, length, sort, cons, ofArray, tryFind, contains, isEmpty, filter, find, map, empty, head } from "../../fable_modules/fable-library.3.7.20/List.js";
import { PeriodModule_toString, CancellationPeriodMonths_toTranslation, MonthsInAdvance_toTranslation, PaymentMethod, PeriodModule_getOptionsV1Contracts, Period, PaymentMethod$reflection, IsoCountryCode$reflection, PeriodModule_toStringTranslation, CancelDateChoiceModule_ofString, CancelDateChoice, PeriodModule_getOptions, PeriodModule_ofString, PeriodModule_getOptionsV2 } from "../../DomainTypes.js";
import { DateModule_ofDateTime, DateModule_today } from "../../Svea.Dry/Time.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { getVatRates, monthsInAdvance as monthsInAdvance_1, cancellationPeriodMonths as cancellationPeriodMonths_1, afterSomeTimeSelects } from "../../CommonData.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { String500_create, FeeFormViewModelValues$reflection, FeeFormViewModelValues } from "./Model.js";
import { addDays, minValue, day, compare, equals, addMonths } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { $007CByte$007C_$007C, DateOnlyExtensions_toDate, DateTimeExtensions_toLastOfMonth, DateTimeExtensions_toDate, DateOnlyExtensions_toDateTime, stackClasses, getRemainingBoundMonthsWithoutCancellationPeriod, Locale$reflection, decimalToTwoDecimals, DateOnlyExtensions_getMonthDiff, parseInt$, logei, parseDecimal } from "../../Utils.js";
import { replace } from "../../fable_modules/fable-library.3.7.20/RegExp.js";
import { printf, toText, isNullOrWhiteSpace } from "../../fable_modules/fable-library.3.7.20/String.js";
import { uncurry, comparePrimitives, safeHash, equals as equals_1, numberHash, stringHash, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { value as value_6, map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { Flatpickr_OnChangeOption, LoadState_map, LoadState_defaultValue, getTranslationFrom } from "../../Global.js";
import { FSharpSet__Contains } from "../../fable_modules/fable-library.3.7.20/Set.js";
import * as react from "react";
import { warning, error } from "../../Components/Message/Message.js";
import { RadioInput, RadioInput_get_getDefault, inputRadio, DateOptions, DateOptions_get_getDefault, inputDate, SelectOption, ValueProp as ValueProp_7, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { DatepickerProps, DatepickerProps_get_getDefault, DatePicker } from "../../Components/StatefulFormFields/Datepicker.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { MinimumDate, DisableRanges, OnChange as OnChange_5, Id as Id_17, Locale, EnableBy, FormatDateBy, Value as Value_5 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { day as day_1 } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { getMaterialIcon } from "../../ViewUtils.js";
import { renderWithButtonProps } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { ButtonProps, ButtonProps_get_getDefault } from "../../Components/Button/Button.js";
import "../../../src/Containers/FeeModal/View.scss";


export class FeeVersion extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["One", "Two"];
    }
}

export function FeeVersion$reflection() {
    return union_type("Containers.FeeModal.View.FeeVersion", [], FeeVersion, () => [[["Item", FeeConfig$reflection()]], [["Item", FeeConfig$reflection()]]]);
}

class FeeFormEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeTemplate", "OnChangeFeeText", "OnChangeAmountExclVat", "OnChangeAmountInclVat", "OnChangeBoundMonths", "OnChangeCancellationPeriodMonths", "OnChangeMonthsInAdvance", "OnChangePeriod", "OnChangeChosenCancelledDate", "OnChangeCancelledDate", "OnChangeStartDate", "OnChangeVatRate", "OnChangeAfterSomeTime", "OnChangeChartofAccount", "OnChangeBilledTo", "OnChangeUnits", "OnChangeBoundToDate"];
    }
}

function FeeFormEvent$reflection() {
    return union_type("Containers.FeeModal.View.FeeFormEvent", [], FeeFormEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", class_type("System.DateOnly")]], [["Item", class_type("System.DateOnly")]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", option_type(class_type("System.DateOnly"))]], [["Item", string_type]], [["Item", option_type(class_type("System.DateOnly"))]]]);
}

export function getInitFeeViewModelValues(getTranslation, feeVersion, monthsInAdvance, cancellationPeriodMonths) {
    const AmountExclVat = fromParts(0, 0, 0, false, 1);
    const AmountInclVat = fromParts(0, 0, 0, false, 1);
    const SelectedCancellationPeriod = head(cancellationPeriodMonths) | 0;
    const SelectedMonthsInAdvance = head(monthsInAdvance) | 0;
    const SelectedPeriod = (feeVersion.tag === 1) ? head(PeriodModule_getOptionsV2(feeVersion.fields[0])) : PeriodModule_ofString(head(PeriodModule_getOptions(getTranslation))[0]);
    const CancelledDate = DateModule_today();
    const StartDate = DateModule_today();
    const SelectedVatRatePercent = fromParts(0, 0, 0, false, 0);
    return new FeeFormViewModelValues(empty(), "", "", AmountExclVat, AmountInclVat, 0, void 0, 0, SelectedCancellationPeriod, SelectedMonthsInAdvance, SelectedPeriod, new CancelDateChoice(0), CancelledDate, parse(head(afterSomeTimeSelects(getTranslation))[0], 511, false, 32), StartDate, SelectedVatRatePercent, new FSharpResult$2(0, void 0), empty(), 0, false, void 0, 1);
}

function modelReducer(getTranslation, feeVersion, state, msg) {
    let s_1_2, parsedMonths_2, parsedMonths_3, parsedMonths_4, matchValue_3, s_1_3, matchValue_6, s_1_1, matchValue_1;
    const setAfterSomeTime = (months, vm) => (new FeeFormViewModelValues(vm.FeeTemplates, vm.SelectedTemplate, vm.Description, vm.AmountExclVat, vm.AmountInclVat, vm.BoundMonths, vm.BoundToDate, vm.RemainingBoundMonths, vm.SelectedCancellationPeriod, vm.SelectedMonthsInAdvance, vm.SelectedPeriod, new CancelDateChoice(2), addMonths(vm.StartDate, months), months, vm.StartDate, vm.SelectedVatRatePercent, vm.ValidationError, vm.ChartOfAccounts, vm.SelectedAccountNo, vm.UseAccountNo, vm.BilledTo, vm.Units));
    switch (msg.tag) {
        case 1: {
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, msg.fields[0], state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 2: {
            const amount = msg.fields[0];
            const parsedAmountOpt = parseDecimal(replace(amount, ",", ".").trim());
            if (parsedAmountOpt == null) {
                logei(`[OnChangeAmountExclVat] Could not parse '${amount}'.`);
                return state;
            }
            else {
                const parsedAmount = parsedAmountOpt;
                return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, parsedAmount, op_Multiply(parsedAmount, op_Addition(new Decimal(1), op_Division(state.SelectedVatRatePercent, (s_1_2 = (new Decimal(0)), ((() => {
                    for (let i_1 = 0; i_1 <= (100 - 1); i_1++) {
                        s_1_2 = op_Addition(s_1_2, new Decimal(1));
                    }
                })(), s_1_2))))), state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
            }
        }
        case 3: {
            const amount_1 = msg.fields[0];
            const parsedAmountOpt_1 = parseDecimal(replace(amount_1, ",", ".").trim());
            if (parsedAmountOpt_1 == null) {
                logei(`[OnChangeAmountInclVat] Could not parse '${amount_1}'.`);
                return state;
            }
            else {
                const parsedAmount_1 = parsedAmountOpt_1;
                return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, op_Division(parsedAmount_1, op_Addition(fromParts(10, 0, 0, false, 1), op_Division(state.SelectedVatRatePercent, fromParts(1000, 0, 0, false, 1)))), parsedAmount_1, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
            }
        }
        case 4: {
            const months_4 = msg.fields[0];
            const parsedMonthsOpt = (months_4 === "") ? (void 0) : parseInt$(replace(months_4, "\\D", ""));
            const newBoundMonths = ((parsedMonthsOpt == null) ? 0 : ((parsedMonthsOpt > 255) ? ((parsedMonths_2 = (parsedMonthsOpt | 0), 255)) : ((parsedMonthsOpt < 0) ? ((parsedMonths_3 = (parsedMonthsOpt | 0), 0)) : ((parsedMonths_4 = (parsedMonthsOpt | 0), parsedMonths_4))))) | 0;
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, newBoundMonths, (newBoundMonths === 0) ? (void 0) : addMonths(state.StartDate, newBoundMonths), state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 5: {
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, parse(msg.fields[0], 511, false, 32), state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 6: {
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, parse(msg.fields[0], 511, false, 32), state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 7: {
            const period_1 = PeriodModule_ofString(msg.fields[0]);
            switch (period_1.tag) {
                case 0: {
                    return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, 0, void 0, state.RemainingBoundMonths, 0, state.SelectedMonthsInAdvance, period_1, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
                }
                case 9: {
                    return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, 0, void 0, state.RemainingBoundMonths, 0, 0, period_1, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
                }
                default: {
                    return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, period_1, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
                }
            }
        }
        case 8: {
            const parsedCancelDateChoice = CancelDateChoiceModule_ofString(msg.fields[0]);
            switch (parsedCancelDateChoice.tag) {
                case 1: {
                    return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, parsedCancelDateChoice, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
                }
                case 2: {
                    return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, parsedCancelDateChoice, addMonths(state.StartDate, state.SelectedAfterSomeTime), state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
                }
                default: {
                    return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, parsedCancelDateChoice, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
                }
            }
        }
        case 9: {
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, msg.fields[0], state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 10: {
            const date = msg.fields[0];
            const cancelledDate_1 = (state.ChosenCancelledDate.tag === 2) ? addMonths(date, state.SelectedAfterSomeTime) : state.CancelledDate;
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, (matchValue_3 = (state.BoundMonths | 0), (matchValue_3 === 0) ? (void 0) : addMonths(date, matchValue_3)), state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, cancelledDate_1, state.SelectedAfterSomeTime, date, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 11: {
            const vatRate_2 = msg.fields[0];
            const parsedVatRateOpt = parseDecimal(replace(vatRate_2, ",", ".").trim());
            if (parsedVatRateOpt == null) {
                logei(`[OnChangeVatRate] Could not parse '${vatRate_2}'.`);
                return state;
            }
            else {
                const parsedVatRate = parsedVatRateOpt;
                return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, op_Multiply(state.AmountExclVat, op_Addition(new Decimal(1), op_Division(parsedVatRate, (s_1_3 = (new Decimal(0)), ((() => {
                    for (let i_2 = 0; i_2 <= (100 - 1); i_2++) {
                        s_1_3 = op_Addition(s_1_3, new Decimal(1));
                    }
                })(), s_1_3))))), state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, parsedVatRate, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
            }
        }
        case 12: {
            return setAfterSomeTime(parse(msg.fields[0], 511, false, 32), state);
        }
        case 13: {
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, parse(msg.fields[0], 511, false, 32), state.UseAccountNo, state.BilledTo, state.Units);
        }
        case 14: {
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, msg.fields[0], state.Units);
        }
        case 15: {
            const matchValue_4 = parseInt$(msg.fields[0]);
            if (matchValue_4 != null) {
                return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, state.BoundMonths, state.BoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, matchValue_4);
            }
            else {
                return state;
            }
        }
        case 16: {
            const dateOpt_1 = msg.fields[0];
            const newBoundToDate = (dateOpt_1 != null) ? (equals(dateOpt_1, state.StartDate) ? (void 0) : dateOpt_1) : (void 0);
            return new FeeFormViewModelValues(state.FeeTemplates, state.SelectedTemplate, state.Description, state.AmountExclVat, state.AmountInclVat, (dateOpt_1 == null) ? 0 : ((matchValue_6 = (DateOnlyExtensions_getMonthDiff(state.StartDate, dateOpt_1) | 0), (matchValue_6 > 255) ? 255 : ((matchValue_6 < 0) ? 0 : matchValue_6))), newBoundToDate, state.RemainingBoundMonths, state.SelectedCancellationPeriod, state.SelectedMonthsInAdvance, state.SelectedPeriod, state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, state.SelectedVatRatePercent, state.ValidationError, state.ChartOfAccounts, state.SelectedAccountNo, state.UseAccountNo, state.BilledTo, state.Units);
        }
        default: {
            const templateIdStr = msg.fields[0];
            if (isNullOrWhiteSpace(templateIdStr)) {
                const AmountExclVat = fromParts(0, 0, 0, false, 1);
                const AmountInclVat = fromParts(0, 0, 0, false, 1);
                const SelectedCancellationPeriod = ((feeVersion.tag === 1) ? head(feeVersion.fields[0].DefaultCancellationPeriodMonths) : parse(head(cancellationPeriodMonths_1(getTranslation))[0], 511, false, 32)) | 0;
                const SelectedMonthsInAdvance = ((feeVersion.tag === 1) ? head(feeVersion.fields[0].DefaultMonthsInAdvance) : parse(head(monthsInAdvance_1(getTranslation))[0], 511, false, 32)) | 0;
                const SelectedPeriod = (feeVersion.tag === 1) ? PeriodModule_ofString(head(map((period) => PeriodModule_toStringTranslation(getTranslation, period), PeriodModule_getOptionsV2(feeVersion.fields[0])))[0]) : PeriodModule_ofString(head(PeriodModule_getOptions(getTranslation))[0]);
                const CancelledDate_1 = DateModule_today();
                const StartDate = DateModule_today();
                const SelectedVatRatePercent = fromParts(0, 0, 0, false, 0);
                return new FeeFormViewModelValues(state.FeeTemplates, "", "", AmountExclVat, AmountInclVat, 0, void 0, state.RemainingBoundMonths, SelectedCancellationPeriod, SelectedMonthsInAdvance, SelectedPeriod, new CancelDateChoice(0), CancelledDate_1, parse(head(afterSomeTimeSelects(getTranslation))[0], 511, false, 32), StartDate, SelectedVatRatePercent, new FSharpResult$2(0, void 0), state.ChartOfAccounts, 0, state.UseAccountNo, state.BilledTo, 1);
            }
            else {
                const selectedTemplateId = parse(templateIdStr, 511, false, 32) | 0;
                const selectedTemplate = find((t) => (t.FeeTemplateNr === selectedTemplateId), state.FeeTemplates);
                const vm_1 = new FeeFormViewModelValues(state.FeeTemplates, templateIdStr, selectedTemplate.Description, selectedTemplate.AmountExclVat, op_Multiply(selectedTemplate.AmountExclVat, op_Addition(new Decimal(1), op_Division(selectedTemplate.VatRatePercent, (s_1_1 = (new Decimal(0)), ((() => {
                    for (let i = 0; i <= (100 - 1); i++) {
                        s_1_1 = op_Addition(s_1_1, new Decimal(1));
                    }
                })(), s_1_1))))), selectedTemplate.BoundMonths, (matchValue_1 = (selectedTemplate.BoundMonths | 0), (matchValue_1 === 0) ? (void 0) : addMonths(state.StartDate, matchValue_1)), state.RemainingBoundMonths, selectedTemplate.CancellationPeriodMonths, selectedTemplate.MonthsInAdvance, PeriodModule_ofString(selectedTemplate.PeriodFreq), state.ChosenCancelledDate, state.CancelledDate, state.SelectedAfterSomeTime, state.StartDate, selectedTemplate.VatRatePercent, state.ValidationError, state.ChartOfAccounts, selectedTemplate.AccountNo, state.UseAccountNo, state.BilledTo, selectedTemplate.Units);
                const template = selectedTemplate;
                const matchValue = [template.UntilFurtherNotice, template.EndFeeAfterMonths];
                if (matchValue[0]) {
                    return new FeeFormViewModelValues(vm_1.FeeTemplates, vm_1.SelectedTemplate, vm_1.Description, vm_1.AmountExclVat, vm_1.AmountInclVat, vm_1.BoundMonths, vm_1.BoundToDate, vm_1.RemainingBoundMonths, vm_1.SelectedCancellationPeriod, vm_1.SelectedMonthsInAdvance, vm_1.SelectedPeriod, new CancelDateChoice(0), vm_1.CancelledDate, vm_1.SelectedAfterSomeTime, vm_1.StartDate, vm_1.SelectedVatRatePercent, vm_1.ValidationError, vm_1.ChartOfAccounts, vm_1.SelectedAccountNo, vm_1.UseAccountNo, vm_1.BilledTo, vm_1.Units);
                }
                else if (matchValue[1] > 0) {
                    return setAfterSomeTime(matchValue[1], vm_1);
                }
                else {
                    return new FeeFormViewModelValues(vm_1.FeeTemplates, vm_1.SelectedTemplate, vm_1.Description, vm_1.AmountExclVat, vm_1.AmountInclVat, vm_1.BoundMonths, vm_1.BoundToDate, vm_1.RemainingBoundMonths, vm_1.SelectedCancellationPeriod, vm_1.SelectedMonthsInAdvance, vm_1.SelectedPeriod, new CancelDateChoice(1), vm_1.CancelledDate, vm_1.SelectedAfterSomeTime, vm_1.StartDate, vm_1.SelectedVatRatePercent, vm_1.ValidationError, vm_1.ChartOfAccounts, vm_1.SelectedAccountNo, vm_1.UseAccountNo, vm_1.BilledTo, vm_1.Units);
                }
            }
        }
    }
}

function getTemplateOptions(contractTypeCode, productNr, feeTemplates, allowedPeriods) {
    return map((feeTemplate) => {
        let arg_1;
        return [int32ToString(feeTemplate.FeeTemplateNr), (arg_1 = decimalToTwoDecimals(feeTemplate.AmountExclVat), toText(printf("%s (%s:-)"))(feeTemplate.Description)(arg_1))];
    }, filter((template) => {
        const matchValue = [template.FeeTemplateUsage, defaultArg(map_1((contractType) => {
            if (isEmpty(template.ValidForContractTypes)) {
                return true;
            }
            else {
                return contains(contractType, template.ValidForContractTypes, {
                    Equals: (x, y) => (x === y),
                    GetHashCode: stringHash,
                });
            }
        }, contractTypeCode), true), defaultArg(map_1((productNr_1) => {
            if (isEmpty(template.ValidForProducts)) {
                return true;
            }
            else {
                return contains(productNr_1, template.ValidForProducts, {
                    Equals: (x_4, y_1) => (x_4 === y_1),
                    GetHashCode: numberHash,
                });
            }
        }, productNr), true), contains(PeriodModule_ofString(template.PeriodFreq), allowedPeriods, {
            Equals: equals_1,
            GetHashCode: safeHash,
        })];
        let pattern_matching_result;
        if (matchValue[0] === 4) {
            if (matchValue[1]) {
                if (matchValue[2]) {
                    if (matchValue[3]) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return true;
            }
            case 1: {
                return false;
            }
        }
    }, feeTemplates));
}

export class FeeType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CreateNewContractFee", "CreateNewCustomerFee", "UpdateExistingContractFee", "UpdateExistingCustomerFee"];
    }
}

export function FeeType$reflection() {
    return union_type("Containers.FeeModal.View.FeeType", [], FeeType, () => [[], [], [], []]);
}

export class FeeModalProps extends Record {
    constructor(InitialFeeFormViewModelValues, ContractTypeCode, ProductNr, Locale, CountryCode, PaymentMethod, MaxFee, IsBilled, OnCancelClick, OnAcceptClick, FeeVersion, FeeType) {
        super();
        this.InitialFeeFormViewModelValues = InitialFeeFormViewModelValues;
        this.ContractTypeCode = ContractTypeCode;
        this.ProductNr = ProductNr;
        this.Locale = Locale;
        this.CountryCode = CountryCode;
        this.PaymentMethod = PaymentMethod;
        this.MaxFee = MaxFee;
        this.IsBilled = IsBilled;
        this.OnCancelClick = OnCancelClick;
        this.OnAcceptClick = OnAcceptClick;
        this.FeeVersion = FeeVersion;
        this.FeeType = FeeType;
    }
}

export function FeeModalProps$reflection() {
    return record_type("Containers.FeeModal.View.FeeModalProps", [], FeeModalProps, () => [["InitialFeeFormViewModelValues", FeeFormViewModelValues$reflection()], ["ContractTypeCode", option_type(string_type)], ["ProductNr", option_type(int32_type)], ["Locale", Locale$reflection()], ["CountryCode", IsoCountryCode$reflection()], ["PaymentMethod", PaymentMethod$reflection()], ["MaxFee", option_type(class_type("System.Decimal"))], ["IsBilled", bool_type], ["OnCancelClick", lambda_type(unit_type, unit_type)], ["OnAcceptClick", lambda_type(FeeFormViewModelValues$reflection(), unit_type)], ["FeeVersion", FeeVersion$reflection()], ["FeeType", FeeType$reflection()]]);
}

export const renderFeeModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, children_5, arg_5, arg_4, inputRecord_1, LabelText_1, inputRecord_2, ValueProp_1, LabelText_2, children_18, inputRecord_3, inputRecord_4, inputRecord_6, children_48, inputRecord_7, children_54, children_50, inputRecord_8, children_52, inputRecord_9, arg_40, arg_39, children_87, children_72, children_66, children_70, children_68, inputRecord_12, DisplayString, inputRecord_13, DisplayString_1, inputRecord_14, DisplayString_2, children_85, children_83, children_124, children_91, children_89, inputRecord_17, children_102, children_100, children_98, children_112, children_110, children_108, children_104, children_122, children_120, children_118, children_114, matchValue_24, inputRecord_19, inputRecord_20, Disabled_8, matchValue_25;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const globalDepsLoadState = useSelector((state_1) => state_1.Model.GlobalDependencies);
    const hasEditStartDatePermission = LoadState_defaultValue(false, LoadState_map((globalDeps) => {
        if (globalDeps.IsAdminUser) {
            return true;
        }
        else {
            return FSharpSet__Contains(globalDeps.Privileges, "Fenix.FrontOfficeAdvanced.EditOrgNr");
        }
    }, globalDepsLoadState));
    const isStartDateEditable = react.useState(false);
    const modelState = react.useReducer((state_2, msg) => modelReducer(getTranslation, props.FeeVersion, state_2, msg), props.InitialFeeFormViewModelValues);
    const vatRates = getVatRates(props.CountryCode);
    const amount = (modelState[0]).AmountExclVat;
    const hasMatchingVat = tryFind((vat) => equals_2(vat, (modelState[0]).SelectedVatRatePercent), vatRates) != null;
    let patternInput;
    let monthlyAmount;
    const matchValue = (modelState[0]).SelectedPeriod;
    switch (matchValue.tag) {
        case 1:
        case 9:
        case 3:
        case 4:
        case 5:
        case 2: {
            monthlyAmount = amount;
            break;
        }
        case 6: {
            monthlyAmount = op_Division(amount, fromParts(30, 0, 0, false, 1));
            break;
        }
        case 7: {
            monthlyAmount = op_Division(amount, fromParts(60, 0, 0, false, 1));
            break;
        }
        case 8: {
            monthlyAmount = op_Division(amount, fromParts(120, 0, 0, false, 1));
            break;
        }
        default: {
            monthlyAmount = amount;
        }
    }
    patternInput = [decimalToTwoDecimals(op_Multiply(new Decimal((modelState[0]).BoundMonths), monthlyAmount)), decimalToTwoDecimals(op_Multiply(new Decimal(getRemainingBoundMonthsWithoutCancellationPeriod((modelState[0]).BilledTo, (modelState[0]).BoundMonths, (modelState[0]).StartDate)), monthlyAmount))];
    let periodOptions;
    const matchValue_1 = props.FeeVersion;
    if (matchValue_1.tag === 1) {
        const feeConfig = matchValue_1.fields[0];
        const allowedChangesAfterBilledTo = ofArray([new Period(1), new Period(3), new Period(4), new Period(5)]);
        const matchValue_4 = props.FeeType;
        switch (matchValue_4.tag) {
            case 0: {
                const matchValue_5 = props.IsBilled && contains((modelState[0]).SelectedPeriod, allowedChangesAfterBilledTo, {
                    Equals: equals_1,
                    GetHashCode: safeHash,
                });
                periodOptions = (matchValue_5 ? map((period_2) => PeriodModule_toStringTranslation(getTranslation, period_2), filter((period_1) => contains(period_1, allowedChangesAfterBilledTo, {
                    Equals: equals_1,
                    GetHashCode: safeHash,
                }), PeriodModule_getOptionsV2(new FeeConfig(feeConfig.OneTime, feeConfig.Monthly, feeConfig.MonthlyDate, feeConfig.MonthlyWith3MonthsInvoice, feeConfig.MonthlyWith6MonthsInvoice, feeConfig.MonthlyWith12MonthsInvoice, feeConfig.QuarterlyDate, feeConfig.HalfYearDate, feeConfig.YearlyDate, false, feeConfig.DefaultMonthsInAdvance, feeConfig.DefaultCancellationPeriodMonths, feeConfig.UsesUnitPrice)))) : map((period) => PeriodModule_toStringTranslation(getTranslation, period), PeriodModule_getOptionsV2(new FeeConfig(feeConfig.OneTime, feeConfig.Monthly, feeConfig.MonthlyDate, feeConfig.MonthlyWith3MonthsInvoice, feeConfig.MonthlyWith6MonthsInvoice, feeConfig.MonthlyWith12MonthsInvoice, feeConfig.QuarterlyDate, feeConfig.HalfYearDate, feeConfig.YearlyDate, false, feeConfig.DefaultMonthsInAdvance, feeConfig.DefaultCancellationPeriodMonths, feeConfig.UsesUnitPrice))));
                break;
            }
            case 1:
            case 3: {
                periodOptions = map((period_3) => PeriodModule_toStringTranslation(getTranslation, period_3), PeriodModule_getOptionsV2(feeConfig));
                break;
            }
            default: {
                const matchValue_5 = props.IsBilled && contains((modelState[0]).SelectedPeriod, allowedChangesAfterBilledTo, {
                    Equals: equals_1,
                    GetHashCode: safeHash,
                });
                periodOptions = (matchValue_5 ? map((period_2) => PeriodModule_toStringTranslation(getTranslation, period_2), filter((period_1) => contains(period_1, allowedChangesAfterBilledTo, {
                    Equals: equals_1,
                    GetHashCode: safeHash,
                }), PeriodModule_getOptionsV2(new FeeConfig(feeConfig.OneTime, feeConfig.Monthly, feeConfig.MonthlyDate, feeConfig.MonthlyWith3MonthsInvoice, feeConfig.MonthlyWith6MonthsInvoice, feeConfig.MonthlyWith12MonthsInvoice, feeConfig.QuarterlyDate, feeConfig.HalfYearDate, feeConfig.YearlyDate, false, feeConfig.DefaultMonthsInAdvance, feeConfig.DefaultCancellationPeriodMonths, feeConfig.UsesUnitPrice)))) : map((period) => PeriodModule_toStringTranslation(getTranslation, period), PeriodModule_getOptionsV2(new FeeConfig(feeConfig.OneTime, feeConfig.Monthly, feeConfig.MonthlyDate, feeConfig.MonthlyWith3MonthsInvoice, feeConfig.MonthlyWith6MonthsInvoice, feeConfig.MonthlyWith12MonthsInvoice, feeConfig.QuarterlyDate, feeConfig.HalfYearDate, feeConfig.YearlyDate, false, feeConfig.DefaultMonthsInAdvance, feeConfig.DefaultCancellationPeriodMonths, feeConfig.UsesUnitPrice))));
            }
        }
    }
    else {
        const matchValue_2 = props.FeeType;
        switch (matchValue_2.tag) {
            case 2: {
                periodOptions = (((modelState[0]).SelectedPeriod.tag === 9) ? PeriodModule_getOptions(getTranslation) : PeriodModule_getOptionsV1Contracts(getTranslation));
                break;
            }
            case 3:
            case 1: {
                periodOptions = PeriodModule_getOptions(getTranslation);
                break;
            }
            default: {
                periodOptions = PeriodModule_getOptionsV1Contracts(getTranslation);
            }
        }
    }
    let inputContainerClasses;
    const matchValue_6 = (modelState[0]).SelectedPeriod;
    switch (matchValue_6.tag) {
        case 0:
        case 9: {
            inputContainerClasses = stackClasses(ofArray(["w-100", "d-none"]));
            break;
        }
        default: {
            inputContainerClasses = "w-100";
        }
    }
    let isStartDateLaterThanBilledTo;
    const matchValue_7 = [(modelState[0]).BilledTo, (modelState[0]).StartDate];
    let pattern_matching_result;
    if (matchValue_7[0] != null) {
        if (compare(matchValue_7[1], matchValue_7[0]) > 0) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            isStartDateLaterThanBilledTo = true;
            break;
        }
        case 1: {
            isStartDateLaterThanBilledTo = false;
            break;
        }
    }
    const errorMessageOpt = ((((equals_1(props.FeeType, new FeeType(2)) ? true : equals_1(props.FeeType, new FeeType(3))) && equals_1(props.InitialFeeFormViewModelValues.SelectedPeriod, new Period(0))) && equals_1((modelState[0]).SelectedPeriod, new Period(1))) && props.IsBilled) ? "Cannot change period from \u0027once\u0027 to \u0027monthly\u0027. Please create a new fee instead." : (isStartDateLaterThanBilledTo ? "Cannot have StartDate later than BilledTo. This has the effect of invoicing not working properly. Please remove BilledTo or change StartDate." : (void 0));
    let errorMessageHtml;
    if (errorMessageOpt == null) {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    else {
        const msg_1 = errorMessageOpt;
        const children = [error(msg_1.split(""))];
        errorMessageHtml = react.createElement("div", {
            className: "d-flex",
        }, ...children);
    }
    let vatRatesHtml;
    let vatRateSelectHtml;
    const children_3 = [selectOption((inputRecord = SelectOption_get_getDefault(), new SelectOption(new ValueProp_7(0, toString((modelState[0]).SelectedVatRatePercent), (e) => {
        const arg_1 = new FeeFormEvent(11, Browser_Types_Event__Event_get_Value(e));
        modelState[1](arg_1);
    }), "fee-modal__vat-select", map((m) => [toText(printf("%M"))(m), toText(printf("%M"))(m)], vatRates), inputRecord.Classes, getTranslation("Containers.FeesTable.Vat"), false, inputRecord.HTMLProps)))];
    vatRateSelectHtml = react.createElement("div", {
        className: "input-small",
    }, ...children_3);
    if (hasMatchingVat) {
        vatRatesHtml = vatRateSelectHtml;
    }
    else {
        const children_7 = [vatRateSelectHtml, (children_5 = [(arg_5 = toString((modelState[0]).SelectedVatRatePercent), (arg_4 = getTranslation("Containers.FeeForm.VatRateProblem"), toText(printf("%s %s."))(arg_4)(arg_5)))], react.createElement("div", {
            className: "create-fee__wrong-rate",
        }, ...children_5))];
        vatRatesHtml = react.createElement("div", {
            className: "w-100",
        }, ...children_7);
    }
    let feeDescriptionTooManyCharsWarningHtml;
    const warningLimit = 59;
    const labelText = getTranslation("Common.FeeText");
    const matchValue_8 = (modelState[0]).Description.length > warningLimit;
    if (matchValue_8) {
        let msg_2;
        const arg_9 = getTranslation("CustomerContract.Invoicee.Subscriptions.Fees.FeeDescriptionWarning2");
        const arg_7 = getTranslation("CustomerContract.Invoicee.Subscriptions.Fees.FeeDescriptionWarning1");
        msg_2 = toText(printf("%s: %s %i %s."))(labelText)(arg_7)(warningLimit)(arg_9);
        feeDescriptionTooManyCharsWarningHtml = warning(msg_2.split(""));
    }
    else {
        feeDescriptionTooManyCharsWarningHtml = react.createElement(react.Fragment, {});
    }
    let billedToHtml;
    const matchValue_10 = props.FeeType;
    switch (matchValue_10.tag) {
        case 1: {
            billedToHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 2:
        case 3: {
            const children_11 = [DatePicker((inputRecord_1 = DatepickerProps_get_getDefault(), (LabelText_1 = getTranslation("Containers.FeeForm.BilledTo"), new DatepickerProps(toList(delay(() => append(singleton(Flatpickr_OnChangeOption((arg_15) => {
                const arg_14 = new FeeFormEvent(14, map_1(DateModule_ofDateTime, arg_15));
                modelState[1](arg_14);
            })), delay(() => append(((modelState[0]).BilledTo != null) ? singleton(Value_5(DateOnlyExtensions_toDateTime(value_6((modelState[0]).BilledTo)))) : empty_1(), delay(() => append(singleton(FormatDateBy((date_1) => DateTimeExtensions_toDate(props.Locale.ILocale, date_1))), delay(() => append((!equals_1(props.PaymentMethod, new PaymentMethod(1))) ? singleton(EnableBy((dt) => {
                const matchValue_9 = (modelState[0]).SelectedPeriod;
                switch (matchValue_9.tag) {
                    case 2:
                    case 6:
                    case 7:
                    case 8: {
                        let lastOfMonth;
                        let copyOfStruct = DateTimeExtensions_toLastOfMonth(dt);
                        lastOfMonth = day(copyOfStruct);
                        if (day_1((modelState[0]).StartDate) > lastOfMonth) {
                            return day(dt) === lastOfMonth;
                        }
                        else {
                            return day(dt) === day_1((modelState[0]).StartDate);
                        }
                    }
                    default: {
                        return day(dt) === 1;
                    }
                }
            })) : empty_1(), delay(() => append(singleton(Locale(props.Locale.FlatpickrLocale)), delay(() => singleton(Id_17("fee-modal__fee-billed-to-date")))))))))))))), LabelText_1, true, inputRecord_1.Disabled, (_arg) => {
                modelState[1](new FeeFormEvent(14, void 0));
            }))))];
            billedToHtml = react.createElement("div", {
                className: "create-fee__input-container fit-content",
            }, ...children_11);
            break;
        }
        default: {
            billedToHtml = react.createElement(react.Fragment, {});
        }
    }
    let chartOfAccountsHtml;
    const matchValue_11 = [(modelState[0]).UseAccountNo, (modelState[0]).ChartOfAccounts];
    let pattern_matching_result_1;
    if (matchValue_11[0]) {
        if (!isEmpty(matchValue_11[1])) {
            pattern_matching_result_1 = 0;
        }
        else {
            pattern_matching_result_1 = 1;
        }
    }
    else {
        pattern_matching_result_1 = 1;
    }
    switch (pattern_matching_result_1) {
        case 0: {
            const children_13 = [selectOption((inputRecord_2 = SelectOption_get_getDefault(), (ValueProp_1 = (new ValueProp_7(0, int32ToString((modelState[0]).SelectedAccountNo), (e_1) => {
                const arg_17 = new FeeFormEvent(13, Browser_Types_Event__Event_get_Value(e_1));
                modelState[1](arg_17);
            })), (LabelText_2 = getTranslation("Common.AccountNo"), new SelectOption(ValueProp_1, "fee-modal__account-number", map((chartOfAccount) => [toString(chartOfAccount.AccountNo), chartOfAccount.Description], matchValue_11[1]), inputRecord_2.Classes, LabelText_2, false, inputRecord_2.HTMLProps)))))];
            chartOfAccountsHtml = react.createElement("div", {
                className: "create-fee__input-container w-200",
            }, ...children_13);
            break;
        }
        case 1: {
            chartOfAccountsHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    let maxFeeWarningHtml;
    const matchValue_12 = props.MaxFee;
    if (matchValue_12 != null) {
        const maxFeeAmount = matchValue_12;
        maxFeeWarningHtml = ((compare_1((modelState[0]).AmountExclVat, maxFeeAmount) > 0) ? warning(getTranslation("Containers.FeeForm.FeeMaxWarning").split("")) : react.createElement(react.Fragment, {}));
    }
    else {
        maxFeeWarningHtml = react.createElement(react.Fragment, {});
    }
    let templatesHtml;
    const matchValue_14 = [props.FeeType, props.IsBilled];
    let pattern_matching_result_2;
    if (matchValue_14[0].tag === 2) {
        if (matchValue_14[1]) {
            pattern_matching_result_2 = 0;
        }
        else {
            pattern_matching_result_2 = 1;
        }
    }
    else if (matchValue_14[0].tag === 3) {
        if (matchValue_14[1]) {
            pattern_matching_result_2 = 0;
        }
        else {
            pattern_matching_result_2 = 1;
        }
    }
    else {
        pattern_matching_result_2 = 1;
    }
    switch (pattern_matching_result_2) {
        case 0: {
            const templateStr = defaultArg(map_1((template_1) => template_1.Description, tryFind((template) => (int32ToString(template.FeeTemplateNr) === (modelState[0]).SelectedTemplate), (modelState[0]).FeeTemplates)), "-");
            const children_22 = [(children_18 = [getTranslation("Containers.FeesTable.FeeForm.Template")], react.createElement("p", {
                className: "text-field__top",
            }, ...children_18)), react.createElement("p", {
                className: "text-field__bottom",
            }, templateStr)];
            templatesHtml = react.createElement("div", {
                className: "create-fee__text-field d-flex flex-column",
            }, ...children_22);
            break;
        }
        case 1: {
            const templateOptions = getTemplateOptions(props.ContractTypeCode, props.ProductNr, (modelState[0]).FeeTemplates, map((arg_18) => PeriodModule_ofString(arg_18[0]), periodOptions));
            templatesHtml = selectOption((inputRecord_3 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_7(0, (modelState[0]).SelectedTemplate, (e_2) => {
                const arg_20 = new FeeFormEvent(0, Browser_Types_Event__Event_get_Value(e_2));
                modelState[1](arg_20);
            }), "fee-modal__fee-templates", cons(["", getTranslation("Containers.FeesTable.FeeForm.ChooseTemplate")], templateOptions), inputRecord_3.Classes, getTranslation("Containers.FeesTable.FeeForm.Template"), false, inputRecord_3.HTMLProps)));
            break;
        }
    }
    let monthsInAdvanceOptions;
    const matchValue_15 = props.FeeVersion;
    if (matchValue_15.tag === 1) {
        const feeConfig_1 = matchValue_15.fields[0];
        monthsInAdvanceOptions = map((months) => [int32ToString(months), MonthsInAdvance_toTranslation(getTranslation, months)], contains(props.InitialFeeFormViewModelValues.SelectedMonthsInAdvance, feeConfig_1.DefaultMonthsInAdvance, {
            Equals: (x_2, y_2) => (x_2 === y_2),
            GetHashCode: numberHash,
        }) ? feeConfig_1.DefaultMonthsInAdvance : sort(cons(props.InitialFeeFormViewModelValues.SelectedMonthsInAdvance, feeConfig_1.DefaultMonthsInAdvance), {
            Compare: comparePrimitives,
        }));
    }
    else {
        monthsInAdvanceOptions = monthsInAdvance_1(getTranslation);
    }
    let cancellationPeriodMonthsOptions;
    const matchValue_17 = props.FeeVersion;
    if (matchValue_17.tag === 1) {
        const feeConfig_2 = matchValue_17.fields[0];
        cancellationPeriodMonthsOptions = map((months_1) => [int32ToString(months_1), CancellationPeriodMonths_toTranslation(getTranslation, months_1)], contains(props.InitialFeeFormViewModelValues.SelectedCancellationPeriod, feeConfig_2.DefaultCancellationPeriodMonths, {
            Equals: (x_4, y_4) => (x_4 === y_4),
            GetHashCode: numberHash,
        }) ? feeConfig_2.DefaultCancellationPeriodMonths : sort(cons(props.InitialFeeFormViewModelValues.SelectedCancellationPeriod, feeConfig_2.DefaultCancellationPeriodMonths), {
            Compare: comparePrimitives,
        }));
    }
    else {
        cancellationPeriodMonthsOptions = cancellationPeriodMonths_1(getTranslation);
    }
    let usesUnitPrice;
    const matchValue_19 = props.FeeVersion;
    let pattern_matching_result_3, config;
    if (matchValue_19.tag === 1) {
        pattern_matching_result_3 = 0;
        config = matchValue_19.fields[0];
    }
    else {
        pattern_matching_result_3 = 0;
        config = matchValue_19.fields[0];
    }
    switch (pattern_matching_result_3) {
        case 0: {
            usesUnitPrice = config.UsesUnitPrice;
            break;
        }
    }
    let selectPeriodHtml;
    const children_24 = [selectOption((inputRecord_4 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_7(0, PeriodModule_toString((modelState[0]).SelectedPeriod), (e_3) => {
        const arg_22 = new FeeFormEvent(7, Browser_Types_Event__Event_get_Value(e_3));
        modelState[1](arg_22);
    }), "fee-modal__select-period", periodOptions, inputRecord_4.Classes, getTranslation("Containers.FeesTable.FeeForm.Type"), inputRecord_4.Disabled, inputRecord_4.HTMLProps)))];
    selectPeriodHtml = react.createElement("div", {
        className: "w-100",
    }, ...children_24);
    let selectMonthsInAdvanceHtml;
    const children_27 = toList(delay(() => {
        let inputRecord_5;
        return (length(monthsInAdvanceOptions) === 1) ? singleton(react.createElement(react.Fragment, {})) : singleton(selectOption((inputRecord_5 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_7(0, int32ToString((modelState[0]).SelectedMonthsInAdvance), (e_4) => {
            const arg_24 = new FeeFormEvent(6, Browser_Types_Event__Event_get_Value(e_4));
            modelState[1](arg_24);
        }), "fee-modal__months-in-advance", monthsInAdvanceOptions, inputRecord_5.Classes, getTranslation("Containers.FeesTable.FeeForm.MonthsInAdvance"), false, inputRecord_5.HTMLProps))));
    }));
    selectMonthsInAdvanceHtml = react.createElement("div", {
        className: "w-100",
    }, ...children_27);
    let unitsHtml;
    if (usesUnitPrice) {
        const children_30 = [render_1()((inputRecord_6 = TextProps$1_GetDefault(), new TextProps$1(int32ToString((modelState[0]).Units), "number", inputRecord_6.Classes, (e_5) => {
            const arg_26 = new FeeFormEvent(15, Browser_Types_Event__Event_get_Value(e_5));
            modelState[1](arg_26);
        }, inputRecord_6.Disabled, getTranslation("Common.Units"), "fee-modal__units", inputRecord_6.ValidationFn, inputRecord_6.DynamicWidth, inputRecord_6.HTMLProps, inputRecord_6.OnBlur, inputRecord_6.OnFocus, inputRecord_6.AutoComplete, inputRecord_6.Name)))];
        unitsHtml = react.createElement("div", {
            className: "input-small",
        }, ...children_30);
    }
    else {
        unitsHtml = react.createElement(react.Fragment, {});
    }
    let totalAmountExclVatHtml;
    if (usesUnitPrice) {
        const totalAmountInclVatStr = decimalToTwoDecimals(op_Multiply((modelState[0]).AmountExclVat, new Decimal((modelState[0]).Units)));
        let translationStr;
        const arg_28 = getTranslation("Common.ExclVat");
        const arg_27 = getTranslation("Containers.FeeForm.TotalAmount");
        translationStr = toText(printf("%s (%s)"))(arg_27)(arg_28);
        const children_37 = [react.createElement("div", {
            className: "text-field__top",
        }, translationStr), react.createElement("div", {
            className: "text-field__bottom",
            id: "fee-modal__total-amount-incl-vat",
        }, totalAmountInclVatStr)];
        totalAmountExclVatHtml = react.createElement("div", {
            className: "d-flex flex-column create-fee__text-field input-large",
            id: "fee-modal__total-excl-vat",
        }, ...children_37);
    }
    else {
        totalAmountExclVatHtml = react.createElement(react.Fragment, {});
    }
    let totalAmountInclVatHtml;
    if (usesUnitPrice) {
        const totalAmountInclVatStr_1 = decimalToTwoDecimals(op_Multiply((modelState[0]).AmountInclVat, new Decimal((modelState[0]).Units)));
        let translationStr_1;
        const arg_30 = getTranslation("Common.InclVat");
        const arg_29 = getTranslation("Containers.FeeForm.TotalAmount");
        translationStr_1 = toText(printf("%s (%s)"))(arg_29)(arg_30);
        const children_44 = [react.createElement("div", {
            className: "text-field__top",
        }, translationStr_1), react.createElement("div", {
            className: "text-field__bottom",
            id: "fee-modal__total-amount-incl-vat",
        }, totalAmountInclVatStr_1)];
        totalAmountInclVatHtml = react.createElement("div", {
            className: "d-flex flex-column create-fee__text-field input-large",
            id: "fee-modal__total-incl-vat",
        }, ...children_44);
    }
    else {
        totalAmountInclVatHtml = react.createElement(react.Fragment, {});
    }
    let bodyHtml;
    const children_126 = [react.createElement("div", {
        className: "create-fee__input-container",
    }, templatesHtml), (children_48 = [render_1()((inputRecord_7 = TextProps$1_GetDefault(), new TextProps$1((modelState[0]).Description, inputRecord_7.Type, inputRecord_7.Classes, (e_6) => {
        const arg_32 = new FeeFormEvent(1, Browser_Types_Event__Event_get_Value(e_6));
        modelState[1](arg_32);
    }, inputRecord_7.Disabled, getTranslation("Common.FeeText"), "fee-modal__fee-text", (arg_34) => String500_create(getTranslation, arg_34), inputRecord_7.DynamicWidth, inputRecord_7.HTMLProps, inputRecord_7.OnBlur, inputRecord_7.OnFocus, inputRecord_7.AutoComplete, inputRecord_7.Name)))], react.createElement("div", {
        className: "create-fee__input-container",
    }, ...children_48)), (children_54 = [unitsHtml, (children_50 = [render_1()((inputRecord_8 = TextProps$1_GetDefault(), new TextProps$1(decimalToTwoDecimals((modelState[0]).AmountExclVat), inputRecord_8.Type, inputRecord_8.Classes, (e_7) => {
        const arg_36 = new FeeFormEvent(2, Browser_Types_Event__Event_get_Value(e_7));
        modelState[1](arg_36);
    }, inputRecord_8.Disabled, usesUnitPrice ? getTranslation("Common.Price") : getTranslation("Common.AmountExclVat"), "fee-modal__amount-excl-vat", inputRecord_8.ValidationFn, inputRecord_8.DynamicWidth, inputRecord_8.HTMLProps, inputRecord_8.OnBlur, inputRecord_8.OnFocus, inputRecord_8.AutoComplete, inputRecord_8.Name)))], react.createElement("div", {
        className: "input-medium",
    }, ...children_50)), (children_52 = [render_1()((inputRecord_9 = TextProps$1_GetDefault(), new TextProps$1(decimalToTwoDecimals((modelState[0]).AmountInclVat), inputRecord_9.Type, inputRecord_9.Classes, (e_8) => {
        const arg_38 = new FeeFormEvent(3, Browser_Types_Event__Event_get_Value(e_8));
        modelState[1](arg_38);
    }, inputRecord_9.Disabled, usesUnitPrice ? ((arg_40 = getTranslation("Common.InclVat").toLocaleLowerCase(), (arg_39 = getTranslation("Common.Price"), toText(printf("%s (%s)"))(arg_39)(arg_40)))) : getTranslation("Common.AmountInclVat"), "fee-modal__amount-incl-vat", inputRecord_9.ValidationFn, inputRecord_9.DynamicWidth, inputRecord_9.HTMLProps, inputRecord_9.OnBlur, inputRecord_9.OnFocus, inputRecord_9.AutoComplete, inputRecord_9.Name)))], react.createElement("div", {
        className: "input-medium",
    }, ...children_52)), vatRatesHtml], react.createElement("div", {
        className: "create-fee__input-container",
    }, ...children_54)), react.createElement("div", {
        className: "create-fee__input-container",
    }, totalAmountExclVatHtml, totalAmountInclVatHtml), react.createElement("div", {
        className: "create-fee__input-container",
    }, selectPeriodHtml, selectMonthsInAdvanceHtml), (children_87 = [(children_72 = [(children_66 = toList(delay(() => {
        let inputRecord_10, LabelText_10, Disabled_4;
        return append(singleton(inputDate((inputRecord_10 = DateOptions_get_getDefault(), (LabelText_10 = getTranslation("Common.StartDate"), (Disabled_4 = ((hasEditStartDatePermission && (isStartDateEditable[0])) ? false : props.IsBilled), new DateOptions(ofArray([OnChange_5((arg_44) => {
            const arg_43 = new FeeFormEvent(10, DateModule_ofDateTime(arg_44));
            modelState[1](arg_43);
        }), Value_5(DateOnlyExtensions_toDateTime((modelState[0]).StartDate)), FormatDateBy((date_3) => DateTimeExtensions_toDate(props.Locale.ILocale, date_3)), Locale(props.Locale.FlatpickrLocale), Id_17("fee-modal__fee-start-date")]), LabelText_10, true, Disabled_4, inputRecord_10.OnClearClick)))))), delay(() => {
            let matchValue_21, children_61;
            return append((matchValue_21 = (hasEditStartDatePermission && (!(isStartDateEditable[0]))), matchValue_21 ? singleton((children_61 = [getMaterialIcon("edit")], react.createElement("div", {
                className: "create-fee__start-date-edit-icon",
                onClick: (_arg_2) => {
                    isStartDateEditable[1](true);
                },
            }, ...children_61))) : singleton(react.createElement(react.Fragment, {}))), delay(() => {
                let children_64, inputRecord_11;
                return (length(cancellationPeriodMonthsOptions) === 1) ? singleton(react.createElement(react.Fragment, {})) : singleton((children_64 = [selectOption((inputRecord_11 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_7(0, int32ToString((modelState[0]).SelectedCancellationPeriod), (e_9) => {
                    const arg_46 = new FeeFormEvent(5, Browser_Types_Event__Event_get_Value(e_9));
                    modelState[1](arg_46);
                }), "fee-modal__cancellation-period-months", cancellationPeriodMonthsOptions, inputRecord_11.Classes, getTranslation("Containers.FeesTable.CancellationPeriod"), false, inputRecord_11.HTMLProps)))], react.createElement("div", {
                    className: inputContainerClasses,
                }, ...children_64)));
            }));
        }));
    })), react.createElement("div", {
        className: "create-fee__input-container flex-column mr-5 position-relative",
    }, ...children_66)), (children_70 = [(children_68 = [inputRadio((inputRecord_12 = RadioInput_get_getDefault(), (DisplayString = getTranslation("Containers.FeeForm.OngoingFee"), new RadioInput("fee-modal__end-date-ongoing", "end-date-group", (e_10) => {
        const arg_48 = new FeeFormEvent(8, Browser_Types_Event__Event_get_Value(e_10));
        modelState[1](arg_48);
    }, toString_1(new CancelDateChoice(0)), DisplayString, equals_1((modelState[0]).ChosenCancelledDate, new CancelDateChoice(0)), inputRecord_12.Disabled)))), inputRadio((inputRecord_13 = RadioInput_get_getDefault(), (DisplayString_1 = getTranslation("Common.EndDate"), new RadioInput("fee-modal__end-date-end-date", "end-date-group", (e_11) => {
        const arg_50 = new FeeFormEvent(8, Browser_Types_Event__Event_get_Value(e_11));
        modelState[1](arg_50);
    }, toString_1(new CancelDateChoice(1)), DisplayString_1, equals_1((modelState[0]).ChosenCancelledDate, new CancelDateChoice(1)), inputRecord_13.Disabled)))), inputRadio((inputRecord_14 = RadioInput_get_getDefault(), (DisplayString_2 = getTranslation("Containers.FeeForm.AfterSomeTime"), new RadioInput("fee-modal__end-date-after-some-time", "end-date-group", (e_12) => {
        const arg_52 = new FeeFormEvent(8, Browser_Types_Event__Event_get_Value(e_12));
        modelState[1](arg_52);
    }, toString_1(new CancelDateChoice(2)), DisplayString_2, equals_1((modelState[0]).ChosenCancelledDate, new CancelDateChoice(2)), inputRecord_14.Disabled))))], react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_68))], react.createElement("div", {
        className: "d-flex flex-column",
    }, ...children_70))], react.createElement("div", {
        className: "d-flex",
    }, ...children_72)), (children_85 = [(children_83 = toList(delay(() => {
        let inputRecord_15, LabelText_12, children_81, inputRecord_16, children_79, children_75, children_77;
        const matchValue_23 = (modelState[0]).ChosenCancelledDate;
        switch (matchValue_23.tag) {
            case 1: {
                return singleton(inputDate((inputRecord_15 = DateOptions_get_getDefault(), (LabelText_12 = getTranslation("Common.EndDate"), new DateOptions(toList(delay(() => append(singleton(FormatDateBy((date_4) => DateTimeExtensions_toDate(props.Locale.ILocale, date_4))), delay(() => append(singleton(Locale(props.Locale.FlatpickrLocale)), delay(() => append(singleton(Id_17("fee-modal__cancelled-date-pickr")), delay(() => append(singleton(OnChange_5((arg_56) => {
                    const arg_55 = new FeeFormEvent(9, DateModule_ofDateTime(arg_56));
                    modelState[1](arg_55);
                })), delay(() => append(((equals_1(props.FeeType, new FeeType(2)) ? true : equals_1(props.FeeType, new FeeType(3))) && ((modelState[0]).BilledTo != null)) ? singleton(DisableRanges(singleton_1([minValue(), addDays(DateOnlyExtensions_toDateTime(value_6((modelState[0]).BilledTo)), -1)]))) : empty_1(), delay(() => singleton(Value_5(DateOnlyExtensions_toDateTime((modelState[0]).CancelledDate))))))))))))))), LabelText_12, true, false, inputRecord_15.OnClearClick)))));
            }
            case 2: {
                return singleton((children_81 = [selectOption((inputRecord_16 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_7(0, int32ToString((modelState[0]).SelectedAfterSomeTime), (e_13) => {
                    const arg_58 = new FeeFormEvent(12, Browser_Types_Event__Event_get_Value(e_13));
                    modelState[1](arg_58);
                }), "fee-modal__after-some-time-select", afterSomeTimeSelects(getTranslation), inputRecord_16.Classes, getTranslation("Containers.FeesTable.FeeForm.AfterSomeTime"), false, inputRecord_16.HTMLProps))), (children_79 = [(children_75 = [getTranslation("Common.EndDate")], react.createElement("p", {
                    className: "mb-1",
                }, ...children_75)), (children_77 = [DateOnlyExtensions_toDate(props.Locale.ILocale, (modelState[0]).CancelledDate)], react.createElement("p", {
                    className: "mb-0",
                }, ...children_77))], react.createElement("div", {
                    className: "create-fee__after-some-time-text d-flex flex-column",
                }, ...children_79))], react.createElement("div", {
                    className: "d-flex flex-column",
                }, ...children_81)));
            }
            default: {
                return singleton(react.createElement(react.Fragment, {}));
            }
        }
    })), react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_83))], react.createElement("div", {
        className: "create-fee__input-container flex-column",
    }, ...children_85))], react.createElement("div", {
        className: "create-fee__input-container",
    }, ...children_87)), (children_124 = [(children_91 = [(children_89 = [render_1()((inputRecord_17 = TextProps$1_GetDefault(), new TextProps$1(int32ToString((modelState[0]).BoundMonths), inputRecord_17.Type, inputRecord_17.Classes, (e_14) => {
        const arg_60 = new FeeFormEvent(4, Browser_Types_Event__Event_get_Value(e_14));
        modelState[1](arg_60);
    }, inputRecord_17.Disabled, getTranslation("Containers.FeesTable.FeeForm.BoundMonths"), "fee-modal__bound-months", (_arg_3) => {
        let activePatternResult, b;
        return (activePatternResult = $007CByte$007C_$007C(_arg_3), (activePatternResult != null) ? ((b = activePatternResult, new FSharpResult$2(0, b))) : (new FSharpResult$2(1, "0-255")));
    }, inputRecord_17.DynamicWidth, inputRecord_17.HTMLProps, inputRecord_17.OnBlur, inputRecord_17.OnFocus, inputRecord_17.AutoComplete, inputRecord_17.Name)))], react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_89))], react.createElement("div", {
        className: "d-flex flex-column w-100",
    }, ...children_91)), (children_102 = [(children_100 = [(children_98 = toList(delay(() => {
        let inputRecord_18, LabelText_15, children_97, children_93, children_95;
        return (globalDepsLoadState.tag === 2) ? (globalDepsLoadState.fields[0].ClientConfig.UsesBoundToDate ? singleton(inputDate((inputRecord_18 = DateOptions_get_getDefault(), (LabelText_15 = getTranslation("Containers.FeeForm.BoundTo"), new DateOptions(ofArray([Flatpickr_OnChangeOption((dateTimeOpt) => {
            const arg_62 = new FeeFormEvent(16, map_1(DateModule_ofDateTime, dateTimeOpt));
            modelState[1](arg_62);
        }), DisableRanges(singleton_1([minValue(), DateOnlyExtensions_toDateTime(addDays((modelState[0]).StartDate, -1))])), Value_5(DateOnlyExtensions_toDateTime(defaultArg((modelState[0]).BoundToDate, (modelState[0]).StartDate))), FormatDateBy((date_8) => DateTimeExtensions_toDate(props.Locale.ILocale, date_8)), Locale(props.Locale.FlatpickrLocale), MinimumDate(DateOnlyExtensions_toDateTime((modelState[0]).StartDate)), Id_17("fee-modal__fee-bound-to-date")]), LabelText_15, true, inputRecord_18.Disabled, inputRecord_18.OnClearClick))))) : singleton((children_97 = [(children_93 = [getTranslation("Containers.FeeForm.BoundTo")], react.createElement("div", {
            className: "text-field__top",
        }, ...children_93)), (children_95 = [DateOnlyExtensions_toDate(props.Locale.ILocale, defaultArg((modelState[0]).BoundToDate, (modelState[0]).StartDate))], react.createElement("div", {
            className: "text-field__bottom",
        }, ...children_95))], react.createElement(react.Fragment, {}, ...children_97)))) : singleton((children_97 = [(children_93 = [getTranslation("Containers.FeeForm.BoundTo")], react.createElement("div", {
            className: "text-field__top",
        }, ...children_93)), (children_95 = [DateOnlyExtensions_toDate(props.Locale.ILocale, defaultArg((modelState[0]).BoundToDate, (modelState[0]).StartDate))], react.createElement("div", {
            className: "text-field__bottom",
        }, ...children_95))], react.createElement(react.Fragment, {}, ...children_97)));
    })), react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_98))], react.createElement("div", {
        className: "create-fee__text-field d-flex flex-column",
    }, ...children_100))], react.createElement("div", {
        className: "d-flex flex-column w-100",
    }, ...children_102)), (children_112 = [(children_110 = [(children_108 = [(children_104 = [getTranslation("Containers.FeeForm.RemainingValue")], react.createElement("div", {
        className: "text-field__top",
    }, ...children_104)), react.createElement("div", {
        className: "text-field__bottom",
    }, patternInput[1])], react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_108))], react.createElement("div", {
        className: "create-fee__text-field d-flex flex-column",
    }, ...children_110))], react.createElement("div", {
        className: "d-flex flex-column w-100",
    }, ...children_112)), (children_122 = [(children_120 = [(children_118 = [(children_114 = [getTranslation("Containers.FeeForm.OriginalValue")], react.createElement("div", {
        className: "text-field__top",
    }, ...children_114)), react.createElement("div", {
        className: "text-field__bottom",
    }, patternInput[0])], react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_118))], react.createElement("div", {
        className: "create-fee__text-field d-flex flex-column",
    }, ...children_120))], react.createElement("div", {
        className: "d-flex flex-column w-100",
    }, ...children_122))], react.createElement("div", {
        className: "create-fee__input-container align-items-center justify-content-between",
    }, ...children_124)), billedToHtml, chartOfAccountsHtml, feeDescriptionTooManyCharsWarningHtml, errorMessageHtml, maxFeeWarningHtml];
    bodyHtml = react.createElement("div", {
        className: "create-fee",
    }, ...children_126);
    return renderWithButtonProps(true, new ModalSize(2), (matchValue_24 = props.FeeType, (matchValue_24.tag === 1) ? getTranslation("Containers.FeesTable.CreateFee") : ((matchValue_24.tag === 2) ? getTranslation("Containers.FeesTable.CreateFee.EditFee") : ((matchValue_24.tag === 3) ? getTranslation("Containers.FeesTable.CreateFee.EditFee") : getTranslation("Containers.FeesTable.CreateFee")))), bodyHtml, (inputRecord_19 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("Containers.FeesTable.CreateFee.Cancel"), inputRecord_19.Content, (_arg_4) => {
        props.OnCancelClick();
    }, inputRecord_19.Disabled, "fee-modal-cancel-btn", inputRecord_19.SaveStatus, inputRecord_19.HTMLProps, inputRecord_19.ExtraClasses, inputRecord_19.Icon)), (inputRecord_20 = ButtonProps_get_getDefault(), (Disabled_8 = (errorMessageOpt != null), new ButtonProps((matchValue_25 = props.FeeType, (matchValue_25.tag === 1) ? getTranslation("Containers.FeesTable.CreateFee.Create") : ((matchValue_25.tag === 2) ? getTranslation("Containers.FeesTable.CreateFee.Save") : ((matchValue_25.tag === 3) ? getTranslation("Containers.FeesTable.CreateFee.Save") : getTranslation("Containers.FeesTable.CreateFee.Create")))), inputRecord_20.Content, (_arg_5) => {
        props.OnAcceptClick(modelState[0]);
    }, Disabled_8, "fee-modal-cancel-btn", inputRecord_20.SaveStatus, inputRecord_20.HTMLProps, inputRecord_20.ExtraClasses, inputRecord_20.Icon))));
}, void 0, uncurry(2, void 0), void 0, "renderFeeModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeeModal\\View.fs", 1120);

